import { Row, Typography, Tabs, Button } from "antd";
import { EllipsisOutlined, EyeOutlined } from "@ant-design/icons";
import _get from "lodash/get";
import { InsuranceColumn } from "components/Columns";
import Table from "components/common/Table";
import { useSelector } from "react-redux";
import { useQuery } from "hooks";
import { getInsuranceListRequest } from "providers/ProductProvider/slice";
import "./styles.less";
import i18n from "i18n";
import SetTagModal from "components/Product/SetTagModal";
import TabHeaderCheckingInsurance from "components/TabHeaderCheckingInsurance";
import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";
import SimpleDropdown from "components/common/SimpleDropdown";

const { TabPane } = Tabs;

const CheckingInsurance = () => {
  const navigate = useNavigate();
  const productList = useSelector((state) => _get(state, "product.docs"));
  const productTotal = useSelector((state) => _get(state, "product.totalDocs"));
  const isLoading = useSelector((state) => _get(state, "product.isLoading"));

  const [searchObject, setSearch] = useQuery(getInsuranceListRequest, {
    params: "warrantyExpires",
  });

  const handleViewOrder = (orderId) => {
    if (orderId) {
      navigate(`/fonehouse/billing_list/${orderId}`);
    }
  };

  const actionColumn = {
    title: "Thao tác",
    key: "action",
    width: 100,
    fixed: "right",
    render: (_, record) => {
      const menuItems = [
        {
          key: "view",
          icon: <EyeOutlined />,
          label: "Xem đơn hàng",
          onClick: () => handleViewOrder(record?.order?._id),
        },
      ];

      return (
        <SimpleDropdown items={menuItems}>
          <Button
            icon={<EllipsisOutlined />}
            type="text"
            size="small"
          />
        </SimpleDropdown>
      );
    },
  };

  const columns = [
    InsuranceColumn.productId,
    InsuranceColumn.customerName,
    InsuranceColumn.customerPhone,
    InsuranceColumn.role,
    InsuranceColumn.name,
    InsuranceColumn.imei,
    InsuranceColumn.saleDate,
    InsuranceColumn.warrantyExpirationDate,
    InsuranceColumn.status,
    actionColumn,
  ];
  return (
    <div className="product-list-wrapper">
      <SetTagModal />
      <Row className="product-list-header" justify="space-between">
        <Typography.Title level={4}>
          {i18n.t("products.insuranceTitle")}
        </Typography.Title>
      </Row>
      <div className="content-container">
        <SearchBar />
        <Tabs
          className="restaurant-tabs-container"
          activeKey={searchObject.warrantyExpires === "1" ? "true" : "false"}
          type="card"
          onChange={(key) => {
            if (key === "true") {
              setSearch(
                {
                  keyword: searchObject.keyword,
                  warrantyExpires: 1,
                },
                true
              );
            } else {
              setSearch(
                {
                  keyword: searchObject.keyword,
                  warrantyExpires: 0,
                },
                true
              );
            }
          }}
        >
          {" "}
          {[false, true].map((value) => (
            <TabPane
              className="status-tab-pane"
              tab={<TabHeaderCheckingInsurance status={value} />}
              key={value}
            >
              <Table
                scroll={{ x: 1000 }}
                loading={isLoading}
                bordered
                columns={columns}
                dataSource={productList}
                rowKey={(data) => data._id}
                total={productTotal}
              />
            </TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default CheckingInsurance;
